import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import useConstants from "@hooks/useConstants";

import Avatar from "@material-ui/core/Avatar";
import Link from "@material-ui/core/Link";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import DesktopMacIcon from "@material-ui/icons/DesktopMac";

const ProPitch = () => {
	const classes = useStyles("Pro");

	const {
		h2,
		img,
		img_alt,
		head_1,
		subhead_1,
		head_2,
		subhead_2,
		head_3,
		subhead_3,
	} = useConstants("ProPitchViewModel");

	return (
		<React.Fragment>
			<Box
				component="section"
				className={classes.quoteWrapper}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"center"}
				bgcolor={"grey.50"}
			>
				<Container maxWidth={false} className={classes.proContainer}>
					<Grid container spacing={8}>
						<Grid item xs={12} sm={6}>
							<Box
								display={"flex"}
								flexDirection={"column"}
								justifyContent={"center"}
								height={"100%"}
							>
								<Box
									component={"h2"}
									fontSize={{ xs: 32, sm: 36 }}
									fontWeight={600}
								>
									{h2}
								</Box>

								<Box mt={10} pr={{ xs: 0, sm: 10 }}>
									<Grid container spacing={8}>
										<Grid item xs={12}>
											<div className={classes.flex}>
												<DesktopMacIcon
													className={classes.stepIcon}
													color={"primary"}
												/>
												<Box ml={4}>
													<div className={classes.stepH}>{head_1}</div>
													<div
														className={classes.stepP}
														dangerouslySetInnerHTML={{
															__html: subhead_1,
														}}
													/>
												</Box>
											</div>
										</Grid>

										<Grid item xs={12}>
											<div className={classes.flex}>
												<EventAvailableIcon
													className={classes.stepIcon}
													color={"primary"}
												/>

												<Box ml={4}>
													<div className={classes.stepH}>{head_2}</div>
													<div className={classes.stepP}>{subhead_2}</div>
												</Box>
											</div>
										</Grid>

										<Grid item xs={12}>
											<div className={classes.flex}>
												<MonetizationOnOutlinedIcon
													className={classes.stepIcon}
													color={"primary"}
												/>

												<Box ml={4}>
													<div className={classes.stepH}>{head_3}</div>
													<div className={classes.stepP}>{subhead_3}</div>
												</Box>
											</div>
										</Grid>
									</Grid>
								</Box>
							</Box>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Box
								width={"100%"}
								height={"100%"}
								display={"inline-block"}
								borderRadius={4}
							>
								<Avatar
									variant="rounded"
									src={img}
									alt={img_alt}
									imgProps={{
										decoding: "async",
										loading: "lazy",
									}}
									style={{ width: "100%", height: "100%" }}
								/>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</React.Fragment>
	);
};

export default ProPitch;
